import { PrivateAxiosInstance } from "config/axios";
const getAuthToken = () => {
  const userDataString = localStorage.getItem("userData");
  const userData = JSON.parse(userDataString);
  return userData?.token;
};

export const API_CREATE_EMAIL_TEMPLATE = async (data) => {
  try {
    const authToken = getAuthToken(); 
    const response = await PrivateAxiosInstance.post(
      "/setting/email_template/create",
      data,
      {
        headers: {
          Authorization: `${authToken}`, 
        },
      }
    );
    return response.data; 
  } catch (error) {
    throw error; 
  }
};

export const API_LIST_EMAIL_TEMPLATE = async (data = {}) => {
  try {
    const authToken = getAuthToken(); 
    const response = await PrivateAxiosInstance.post(
      "/setting/email_template/list",
      data,
      {
        headers: {
          Authorization: `${authToken}`, 
        },
      }
    );
    return response.data; 
  } catch (error) {
    throw error; 
  }
};

export const API_SINGLE_ElEMENT = async (data = {}) => {
  try {
    const authToken = getAuthToken(); 
    const response = await PrivateAxiosInstance.post(
      "/setting/email_template/get",
      data,
      {
        headers: {
          Authorization: `${authToken}`, 
        },
      }
    );
    return response.data; 
  } catch (error) {
    throw error; 
  }
};
// CONSTANTS?.BACKEND_URL

export const API_TEMPLATE_UPDATE = async (data = {}) => {
  try {
    const authToken = getAuthToken(); 
    const response = await PrivateAxiosInstance.post(
      "/setting/email_template/create_email_template",
      data,
      {
        headers: {
          Authorization: `${authToken}`, 
        },
      }
    );
    return response.data; 
  } catch (error) {
    throw error; 
  }
};
